import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import find from 'lodash/find';
import { GroupListPanel, ZeroState, userAgent } from 'ecs-react-components/dist/index.es';
import {
  educationArticleRequested,
  loadArticles,
  archivedCount,
  loadViewPreference,
  putViewPreference,
} from '../../redux/modules/education/education-middleware';
import { mapArticles } from '../../redux/modules/education/education-mapper';

import Header from '../../components/Header/Header';
import { messages, viewSelectionPreferences } from './EducationArticles.i18n';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';

import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

const EDUCATION_VIEW_AUDIT_TYPE = 'educationviewauditevent';

class EducationArticles extends Component {
  constructor() {
    super();
    this.state = { dropdownIsOpen: false };
  }

  componentDidMount() {
    if (this.props.patient.patientId) {
      this.props.dispatch(auditRequest(EDUCATION_VIEW_AUDIT_TYPE, this.props.patient.patientId));
      this.props.dispatch(
        callWithLoadingIndicator(
          'EducationArticles', () => this.props.dispatch(loadArticles(this.props.patient.patientId))));
      this.props.dispatch(archivedCount(this.props.patient.patientId));
      this.props.dispatch(loadViewPreference(this.props.patient.userId));
    }
  }

  getGroups(articles) {
    const { formatMessage } = this.props.intl;
    const result = [];
    Object.keys(articles).forEach((key, index) => {
      if (Object.prototype.hasOwnProperty.call(articles, key)) {
        result.push({
          keyIndex: 'header_' + (index),
          title: formatMessage(messages.groupPanel.assignedOn, { assignedDate: key }),
          subGroups: articles[key],
        });
      }
    });

    return result;
  }

  toggleDropdown = () => this.setState({ dropdownIsOpen: !this.state.dropdownIsOpen })

  refreshArticleList = (e) =>
    this.props.dispatch(loadArticles(this.props.patient.patientId, e.target.checked));

  handleDisplayTypeSelect = (disp) => () => {
    this.props.dispatch(putViewPreference(disp));
    this.toggleDropdown();
    // set some bootstrap classes that don't otherwise get set, because of the layering of
    // the div and iframe (fixes IE issue)
    // const previewDropdown = ReactDOM.findDOMNode(this.previewDropdown);
    const previewDropdown = this.previewDropdown;
    previewDropdown.className = 'dropdown';
    if (previewDropdown.firstChild) {
      previewDropdown.firstChild.setAttribute('aria-expanded', 'false');
    }
  }

  displayTypeText(disp) {
    return <FormattedMessage {...disp} />;
  }

  render() {
    const { formatMessage } = this.props.intl;

    const educationArticles = mapArticles(
      this.props.educationArticles,
      educationArticleRequested,
      this.props.dispatch,
      this.props.viewSelectionPreference.value,
      this.props.selectedArticleId,
      this.props.language
    );
    const assignmentsPresent = this.props.educationArticles && this.props.educationArticles.length > 0;
    const currentDisplayType = find(viewSelectionPreferences, { key: this.props.viewSelectionPreference.value });

    return (
      <div id="education-content">
        <Header headerTitle={<FormattedMessage { ...messages.page.title } /> }
          badgeNumber={this.props.unreadEducationCount}
        />
        <LoadingIndicatorContainer loadingKey="EducationArticles" >
          {
          !assignmentsPresent ?
            (
              <ZeroState
                zeroStateMessage={ <FormattedMessage { ...messages.page.noArticles } /> }
                stateIconCss="fa fa-mortar-board"
              />
            ) :
            (
              <>
                <div className="row mb-1">
                  <div className="col-6">
                    <div className="small mt-2">
                      <Form.Check
                        id="refreshArticleCheck"
                        type="checkbox"
                        label={formatMessage(messages.page.showArchived,
                          {
                            numArchived: this.props.archivedArticlesCount !== 0 ?
                              this.props.archivedArticlesCount :
                              '0',
                          })}
                        onClick={this.refreshArticleList}
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className={'dropdown float-right d-none d-lg-block' + (userAgent('iPad') ? ' hidden' : '')} >
                          <Dropdown ref={ (navDropdown) => { this.previewDropdown = navDropdown; } }>
                          <Dropdown.Toggle className="btn btn-link" as="button" role="button">
                            {this.displayTypeText(currentDisplayType)}
                          </Dropdown.Toggle>
                          <Dropdown.Menu as="ul">
                          {
                            viewSelectionPreferences.map((disp) =>
                              (
                              <div key={'div' + disp.id}>
                                <iframe
                                  src="about:blank"
                                  style={ { position: 'absolute',
                                    zIndex: '-2',
                                    border: 'none',
                                    outline: 'none',
                                    height: '50%' }}
                                  title="View Selected"
                                >
                                </iframe>
                                <Dropdown.Item key={disp.id} as="li"
                                  onClick={this.handleDisplayTypeSelect(disp.key)}
                                  data-qa-item="viewSelector"
                                >
                                  {this.displayTypeText(disp)}
                                </Dropdown.Item>
                              </div>))
                          }
                          </Dropdown.Menu>
                          </Dropdown>
                    </div>
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col-lg-4 custom-list-wrapper">
                    <GroupListPanel
                      actionItemType="button"
                      groups={ this.getGroups(educationArticles) }
                    />
                  </div>
                  <div className="col-lg-8 d-none d-lg-block border border-secondary-subtle p-2">
                    {
                      this.props.inPageArticleUrl ?
                        <iframe className="custom-list-wrapper viewPortObject"
                          src={this.props.inPageArticleUrl}
                          title="Article"
                        >
                        </iframe> :
                        <ZeroState
                          zeroStateMessage={ <FormattedMessage { ...messages.page.articlesPresentNoneSelected } /> }
                          stateIconCss="fa-regular fa-file-lines"
                        />
                    }
                  </div>
                </div>
              </>
            )
          }
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

EducationArticles.propTypes = {
  dispatch: PropTypes.func.isRequired,
  intl: PropTypes.object,
  educationArticles: PropTypes.array,
  unreadEducationCount: PropTypes.number,
  selectedArticleId: PropTypes.string,
  archivedArticlesCount: PropTypes.number,
  viewSelectionPreference: PropTypes.object,
  patient: PropTypes.object,
  showArchived: PropTypes.bool,
  inPageArticleUrl: PropTypes.string,
  language: PropTypes.string,
};

const mapStateToProps = (state) => ({
  educationArticles: state.education.educationArticles,
  unreadEducationCount: state.education.unreadArticlesCount,
  selectedArticleId: state.education.selectedArticleId,
  archivedArticlesCount: state.education.archivedArticlesCount,
  viewSelectionPreference: state.education.viewSelectionPreference,
  inPageArticleUrl: state.education.inPageArticleUrl,
  patient: state.profile.patient,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(injectIntl(EducationArticles));